import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericService } from "app/_services/generic.service";
import { Observable } from "rxjs";
import { TemplateModel } from "./Models/template.model";
import { map } from 'rxjs/operators';
import { SharedService } from "app/_services";
@Injectable({
  providedIn: 'root',
})

export class TemplateService extends GenericService<TemplateModel> {
  constructor(private http: HttpClient,private sharedService: SharedService) {
    super(http, '/Template/',)
  }

  private generateHeaders() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      }),
    };
  }

  getTemplatesByHelpPlanId(helpPlanId:string, language: string): Observable<any> {
    const query = this.sharedService.formatObjectToQueryString({helpPlanId,language});
    const URI = `${this.rootUrl}/Template/GetTemplatesByHelpPlanId/?${query}`;
    return this._http.get(URI,this.prepareHeader()).pipe(map(res => res as any))
  }

  public prepareHeader(): Object {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' });
    return { headers: headers };
}

  previewTemplate( templateName): Observable<any>  {
    return this._http.get(
        this.rootUrl+"/DossierAttachment/previewTemplate/"+templateName, this.prepareHeader()).pipe(map(res => res as any)
    );
}
  getbase64DocxTemplate( templateName): Observable<any>  {
    return this._http.get(
        this.rootUrl+"/DossierAttachment/DownloadDocx/"+templateName, this.prepareHeader()).pipe(map(res => res as any)
    );
  }
  setbase64DocxTemplate( templateName , base64Docx): Observable<any>  {
    return this._http.post(
        this.rootUrl+"/DossierAttachment/UploadTemplate/"+templateName,{ base64Docx },this.prepareHeader());
  }
  
}